export enum OverlayType {
  guidedBoxOverlay = 'guidedBoxOverlay',
  neighborhoodEntryOverlay = 'neighborhoodEntryOverlay',
  neighborhoodHeadOverlay = 'neighborhoodHeadOverlay',
  deleteIconOverlay = 'deleteIconOverlay',
  nodeOpenNotesButtonOverlay = 'nodeOpenNotesButtonOverlay',
  notesIconOverlay = 'nodeNotesIconOverlay',
  treatmentPlanOverlayBehaviour = 'treatmentPlanOverlayBehaviour',
}
